import { ReactNode } from "react";
import styled from "@emotion/styled";
import Spinner from "react-bootstrap/Spinner";

type WidgetContentProps = {
    title: string;
    subTitle?: string;
    loading?: boolean;
    children: ReactNode;
};

const StyledWidgetContent = styled.div`
    width: 100%;
    height: 100%;
    background-color: #2f3a51;
    padding: 16px;
    color: #ffffff;
    line-height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
`;

const WidgetTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 15px;
    line-height: 1.5;
    flex-shrink: 0;
`;

const WidgetSubtitle = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: #828fab;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.5;
    flex-shrink: 0;
`;

const WidgetBody = styled.div`
    flex: 1;
`;

const LoadingIndicator = () => {
    return <Spinner animation="border" variant="primary" />;
};

const WidgetContent = ({
    title,
    subTitle,
    children,
    loading = false,
}: WidgetContentProps) => {
    const defaultWidgetTitle = "Widget";
    const widgetTitle = title || defaultWidgetTitle;

    return (
        <StyledWidgetContent>
            <div>
                <WidgetTitle>{widgetTitle}</WidgetTitle>
                {subTitle && <WidgetSubtitle>{subTitle}</WidgetSubtitle>}
            </div>
            <WidgetBody>{loading ? <LoadingIndicator /> : children}</WidgetBody>
        </StyledWidgetContent>
    );
};

export default WidgetContent;
